import React, {useRef, useEffect, useState, useCallback} from 'react';
import ScriptVariables from './ScriptVariables.js';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js";
import ScriptTidals from './ScriptTidals.js';
import TidalVariables from './TidalVariables.js';
import LoadScript from './LoadScript.js';
import ScriptGraphics from './ScriptGraphics.js';
import {USER_SCRIPT} from 'constants/script-types.js';
import MatchingParenthesis from './MatchingParenthesis.js';
import SaveScript from './SaveScript.js';
import SyntaxHighlighter from './SyntaxHighlighter.js';
import Possibilities from './Possibilities.js';
import {usePreventDragging} from 'components/effects/preventDragging.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import EffectParameterSlider from '../EffectParameterSlider.js';
import { Input } from 'reactstrap';
import {useSyntaxHelper} from './useSyntaxHelper.js';
import {completeBrace, autoIndent} from './autoindent.js';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/themes/prism-dark.css';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import '../../../scripting.scss';
import '../../../Syntax.scss';
window.startColor = "#ff4d24";
window.hueShift = 4;
const colors = new Colors();

let counter = 0;

const UserScriptComponent = ({
    tidals=[],
    isDraggable,
    logs,
    scriptType=USER_SCRIPT,
    effect,
    sequencerEngine,
    variables,
    lang=languages.js,
    doc,
    setExpanded,
    disableSyntaxHelper,
    expanded,
    width,
    height}) => {
    const ref = useRef(undefined);
    const input = useRef(undefined);
    const [isSaving, setIsSaving] = useState(false);
    let scrollElement = useRef(undefined);
    let preElement = useRef(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState(effect.code);
    const caret = useRef(0);
    let shouldIndent = useRef(false);
    let shouldComplete = useRef(false);
    const [running, setRunning] = useState(false);
    const [syntaxError, setSyntaxError] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);
    const {preventDragging} = usePreventDragging({ref});

    useEffect(() => {
        setCode(effect.code);
    }, [effect, effect.code, setCode]);

    useEffect(() => {
        if (effect && effect.expanded && scriptType === USER_SCRIPT) {
            setExpanded(true);
        }
    }, []);

        useConsumeWheel(ref);

    const onChange = useCallback((e) => {
        let el = input.current;
        if (el) {
            setScrollTop(el.scrollTop);
        }
        setCode(e.target.value);
        let _counter = ++counter;
        setTimeout(() => {
            if (_counter !== counter) return;
            if (effect.hasSyntaxError(e.target.value)) {
                setSyntaxError(true);
            } else {
                setSyntaxError(false);
            }
        }, 1000);
    }, [setCode, setSyntaxError, setScrollTop]);

    const {library, setLibrary, choosePossibility, possibilities, setPossibilities, selectedChoice, matchingParenthesis} =
          useSyntaxHelper({ref: input, code, onChange, doc, disable: disableSyntaxHelper});

    useEffect(() => {
        if (!shouldIndent.current && !shouldComplete.current) {
            return;
        }
        if (!input.current) {
            return;
        }
        
        if (shouldIndent.current) {
            shouldIndent.current = false;
            let ret = autoIndent(code, caret.current + 1);
            if (ret.indented === code) {
                return;
            }
            replaceCode(ret.indented, ret.caret);
       }

        if (shouldComplete.current) {
            let brace = shouldComplete.current;
            shouldComplete.current = undefined;
            let _caret = caret.current + 1;
            let _code = completeBrace(brace, code, caret.current + 1);
            replaceCode(_code, _caret);
       }

    }, [code, setCode]);

    const replaceCode = useCallback((_code, caret) => {
        let scrollTop = scrollElement.current.scrollTop;
        let resize = input.current.style.resize;
        let overflow = input.current.style.overflow;
        input.current.style.resize = 'none';
        scrollElement.current.style.overflow = 'hidden';
        input.current.style.overflow = 'hidden';
        input.current.blur();
        setCode(_code);
        setTimeout(() => {
            input.current.setSelectionRange(caret, caret);
            scrollElement.current.scrollTo(0, scrollTop);
            input.current.style.resize = resize;
            input.current.focus();
            scrollElement.current.style.overflow = 'scroll';
            input.current.style.overflow = overflow;
        }, 10);
    }, [setCode]);

    useEffect(() => {
        setCode(effect.code);
        let el = input.current;
        if (el) {
            el.addEventListener('scroll', onScroll);
        }
        return unbindScrolling;
    }, [effect, setCode]);

    function unbindScrolling() {
        let el = document.getElementById(effect.id + '-script');
        if (el) {
            el.removeEventListener('scroll', onScroll);
        }
    }

    const onScroll = useCallback(() => {
        let el = document.getElementById(effect.id + '-script');
        if (el) {
            setScrollTop(el.scrollTop);
        }
    }, [setScrollTop]);

    const saveScript = useCallback(() => {
    }, [code]);

    const execute = useCallback(() => {
        if (!effect.eval(code, undefined, true)) {
        }
        setRunning(true);
        setTimeout(() => setRunning(false), 100);
    }, [code, setRunning]);

    const onKeyUp = useCallback((e) => {
        if (input.current) {
            caret.current = input.current.selectionStart;
        }
        if (e.key === 'Enter' && e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault();
            execute();
        } else if (e.key === 'Enter') {
            shouldIndent.current = true;
        } else if (e.key === '{') {
            shouldComplete.current = '}';
        } else if (e.key === '(') {
            //shouldComplete.current = ')';
        } else if (e.key === '\"') {
            //shouldComplete.current = '\"';
        } else if (e.key === '[') {
            //shouldComplete.current = ']';
        }
    }, [execute]);


    let executeClass = "execute-button";
    let containerClass = "user-script-component";
    if (running) {
        executeClass += " running";
        containerClass += " running";
    }

    useEffect(() => {
        input.current = document.getElementById(effect.id + '-script');
    }, [effect]);

    if (expanded){
        containerClass += " expanded";
    }

    let parsedLog = '';
    if (logs) {
        parsedLog = logs[logs.length - 1];
    }
    let totalClass = "script-and-tidal";
    if (expanded && effect.name === "User Script") totalClass += " expanded";
    if (syntaxError) {
        containerClass += " syntax-error";
    }

    return (
        <div className={totalClass}>
          <div ref={ref} className={containerClass}>
          {setExpanded ? <img
                           onClick={() => {
                               effect.expanded = expanded ? false : true;
                               setExpanded(expanded ? undefined : effect);
                           }}
                           className="expanded-icon" src="/expand-icon.svg"/> : ''}
          <div
            draggable={true}
            ref={scrollElement}
            onDragStart={(e) => e.preventDefault()}
            onMouseDown={() => {
                setPossibilities([]);
                setLibrary(undefined);
            }}
            style={expanded ? {
                height: 340
            } : height ?
                   {
                       height, width
                   } : {}}
            className="script-box">
            <SaveScript scriptType={scriptType} setIsSaving={setIsSaving} code={code} isSaving={isSaving}/>
            <LoadScript setCode={setCode} code={code} scriptType={scriptType} setIsLoading={setIsLoading} code={code} isLoading={isLoading}/>
            <Editor
              textareaId={effect.id + '-script'}
              value={code || ""}
              onValueChange={code => onChange({target: {value: code}})}
              highlight={code => highlight(code, lang)}
              onKeyDown={onKeyUp}
              onMouseDown={(e) => {
                  e.stopPropagation();
              }}
              spellCheck="false"
              className="user-script-code"/>
            <Highlighter scrollTop={scrollTop} running={running}
                         lineNumber={effect.syntaxErrorLine}
                         syntaxErrors={effect.syntaxErrors}
                         syntaxError={syntaxError} code={code}/>
            <MatchingParenthesis matchingParenthesis={matchingParenthesis}/>
            <Possibilities
              library={library}
              setLibrary={setLibrary}
              doc={doc}
              effect={effect}
              selectedChoice={selectedChoice}
              choosePossibility={choosePossibility}
              scrollTop={scrollTop}
              input={input}
              setPossibilities={setPossibilities}
              possibilities={possibilities}/>
          </div>
          {!isLoading && !isSaving ? 
           <div className="script-toolbar">
             <div
               className={"load-script-btn"}
               onClick={() => setIsLoading(true)}
             >
               Load
             </div>
             <div
               className={"save-script-btn"}
               onClick={() => setIsSaving(true)}
             >
               Save
             </div>
             <div
               className={executeClass}
               onClick={execute}
             >
               <div className="arrow-right"></div>
               <span>
                 Run
               </span>
             </div>
           </div>
           : ''}
          <ScriptGraphics effect={effect}/>
          <ScriptVariables sequencerEngine={sequencerEngine} effect={effect}/>
         <div className="log-display">
            {parsedLog}
          </div>
        </div>
          {/*<ScriptTidals tidals={tidals} isScript={true}/>*/}
        </div>
    );
};



const Highlighter = ({syntaxErrors, code, lineNumber, running, syntaxError, scrollTop}) => {
    if (!syntaxErrors || syntaxErrors.length === 0) {
        return '';
    }
    let splitted = (code || "").split("\n");
    const height = 19;
    const CHAR_WIDTH = 9;
    let className = "highlighter";
    if (running) {
        className += " running";
    }
    let color = colors.saturate(window.startColor, 1);
    return splitted.map(
        (line, i) => (
            <div
              key={i}
              style={{
                  //backgroundColor: colors.hueShift(color, i*window.hueShift),
                  width: line.length*0.5 + 'em', top: -2 + height * i - scrollTop, height: height}}
              className={(syntaxErrors && syntaxErrors.some(x => x.lineNumber === i+1)) || (syntaxError && i+1 === lineNumber) ? "syntax-error " + className : className}>
            </div>));
};

const mapStateToProps = (state, props) => {
    return {
        syntaxErrorLine: props.effect.syntaxErrorLine,
        code: props.effect.code,
        tidals: props.effect.tidals,
        variables: state.effects.scriptVariables[props.effect.id],
        logs: props.effect.logs,
        logNum: props.effect.logs && props.effect.logs.length,
        syntaxErrors: props.effect.syntaxErrors
    };
};

export default connect(mapStateToProps, null)(UserScriptComponent);
